export default {
  container: {
    boxSizing: 'border-box',
    paddingTop: 'var(--dpoday-banner-height, 0px)',
  },
}
